import { render, staticRenderFns } from "./IconeRelogio.vue?vue&type=template&id=02eae850&scoped=true"
import script from "./IconeRelogio.vue?vue&type=script&lang=js"
export * from "./IconeRelogio.vue?vue&type=script&lang=js"
import style0 from "./IconeRelogio.vue?vue&type=style&index=0&id=02eae850&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eae850",
  null
  
)

export default component.exports